import PropTypes from "prop-types";
import GenericDialog from "../../../../../components/ui/dialogs/generic-dialog/GenericDialog";
import {Button, Grid, Typography} from "@material-ui/core";
import InlineRadioButtons
    from "../../../../../components/ui/inputs/radio-buttons/inline-radio-buttons/InlineRadioButtons";
import React, {useState} from "react";
import ButtonWithProgress from "../../../../../components/ui/buttons/button-with-progress/ButtonWithProgress";
import SimOptionsService from "../../../../../api/simOptionsService";
import {toastError} from "../../../toast/Toast";
import {
    ConfirmationDialog
} from "../../../../../components/mobile/sub-menu-items/sim/Dialogs/confirmation-dialog/ConfirmationDialog";
import {useSelector} from "react-redux";

const ChangeExtraGbStatusDialog = (props) => {
    const [selectedRadioBtn, setSelectedRadioBtn] = useState(
        props.token.optionName.includes("Abilitato") ? "Abilitato" : "Disabilitato"
    )
    const [isLoading, setIsLoading] = useState(false)
    const [openConfirmation, setOpenConfirmation] = useState(false)
    const integrationId = useSelector((state) => state.authReducer.selectedCompany.integrationId)
    const isConfermaButtonDisabled = (props.token.optionName.includes("Abilitato") && selectedRadioBtn === "Abilitato") ||
        (!props.token.optionName.includes("Abilitato") && selectedRadioBtn === "Disabilitato")
    const radioButtons =
        [
            {text: "Abilitato", value: "Abilitato"},
            {text: "Disabilitato", value: "Disabilitato"},
        ]

    const handleRadioBtnChange = (e) => {
        setSelectedRadioBtn(e.target.value)
    }

    const handleConfermaClick = () => {
        setIsLoading(true)
        const body = {
            integrationId: integrationId,
            msisdn: props.sim.msisdn,
            newStatus: selectedRadioBtn
        }
        SimOptionsService.modifyEnablingClass(body).then(() => {
            setOpenConfirmation(true)
        }).catch(() => {
            toastError('Operazione non riuscita. Riprovare.')
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleConfirmationDialogClose = () => {
        setOpenConfirmation(false)
        props.handleDialogClose()
    }

    const dialogContent = (
        <>
            <Typography variant={"body2"}>
                In casi di Extra GB abilitato, il gettone scatta all'esaurimento del Plafond.
                <br/>
                Se disabilitato non scatta alcun gettone
            </Typography>
            <InlineRadioButtons value={selectedRadioBtn} label="Extra GB"
                                radioButtons={radioButtons}
                                handleChange={handleRadioBtnChange}/>
        </>
    )

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button autoFocus onClick={props.handleDialogClose} color="primary" variant="outlined">
                Annulla
            </Button>

            <ButtonWithProgress handleClick={handleConfermaClick}
                                text={"Conferma"}
                                disabled={isConfermaButtonDisabled}
                                loading={isLoading}/>
        </Grid>
    );

    return (
        <GenericDialog open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       dialogContent={dialogContent}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogActions={dialogActions}
                       dialogWidth={"md"}>
            <Typography variant={"h6"}>
                Gestione del gettone Extra GB
            </Typography>
            {openConfirmation ? <ConfirmationDialog dialogTitle={"Gestione del gettone Extra GB"}
                                                    content={
                                                        ["La modifica del comportamento del Gettone Extra GB sarà attiva entro pochi minuti"]
                                                    }
                                                    open={openConfirmation}
                                                    handleDialogClose={handleConfirmationDialogClose}/>
                : null}
        </GenericDialog>
    )
}

ChangeExtraGbStatusDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    token: PropTypes.shape({
        optionName: PropTypes.string.isRequired
    }).isRequired,
    sim: PropTypes.shape({
        iccId: PropTypes.string.isRequired,
        msisdn: PropTypes.string.isRequired
    }).isRequired,
}

export default ChangeExtraGbStatusDialog;
